import type * as React from 'react';

import styles from './styles.module.scss';

interface NotificationPanelWrapperProps {
  children: React.ReactNode;
}

const NotificationPanelWrapper: React.FC<NotificationPanelWrapperProps> = props => (
  <div className={styles['notificationpanel-container']}>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className={styles['notificationpanel-container__content']}>{props.children}</div>
        </div>
      </div>
    </div>
  </div>
);

export default NotificationPanelWrapper;
